import { useState } from 'react'
import './nav.style.css'
import { AiOutlineHome, AiOutlineUser, AiTwotoneAudio } from 'react-icons/ai'
import { BiBookBookmark } from 'react-icons/bi'
import { RiGalleryFill } from 'react-icons/ri'
import { BiMessageRoundedDetail } from 'react-icons/bi'
import { Link as LinkS } from 'react-scroll'

const Nav = () => {
  const [activeNav, setActveNav] = useState('#')

  return (
    <nav>
      <LinkS
        to="header"
        className='linkR'
        smooth={true}
        duration={200}
        spy={true}
        exact='true'
      >
        <AiOutlineHome />
      </LinkS>

      <LinkS
        to="about"
        className='linkR'
        smooth={true}
        duration={200}
        spy={true}
        exact='true'
      >
        <AiOutlineUser />
      </LinkS>

      <LinkS
        to="experience"
        className='linkR'
        smooth={true}
        duration={200}
        spy={true}
        exact='true'
      >
        <BiBookBookmark />
      </LinkS>

      <LinkS
        to="portfolio"
        className='linkR'
        smooth={true}
        duration={200}
        spy={true}
        exact='true'
      >
        <RiGalleryFill />
      </LinkS>

      <LinkS
        to="contact"
        className='linkR'
        smooth={true}
        duration={200}
        spy={true}
        exact='true'
      >
        <BiMessageRoundedDetail />
      </LinkS>
    </nav>
  )
}

export default Nav
